import { amtReg, goodQQEmailReg, billNameReg, billNameRegMsg, emailReg } from '../../../constants/regConstants'

/**
 * 整表校验（遍历校验各行）
 * @param {Array} dataResource [record1,record2....]
 * @param {Array } projectArr 根据用户权限获取的用途数组
 */
function getDataResourceWithValid(dataResource, projectArr) {
    return dataResource.map((record) => {
        return getRecordWithValid(record, projectArr);
    });
}

/**
 * 整行校验并在record添加校验结果
 * @param {object } record 一行的数据：{开立票据名称:'方世玉',身份证号:'320...xx',...,Email:'xx@xx.xx'}
 * @param {Array } projectArr 根据用户权限获取的用途数组
 */
function getRecordWithValid(record, projectArr) {
    // console.log(`getRecordWithValid record:`, record, `projectArr:`, projectArr)
    //对生成B表的数据，替换换行符
    record['开立票据名称'] = (record['开立票据名称'] + '').trim().replaceAll('\n', '、');
    record['金额'] = (record['金额'] + '').trim().replaceAll('\n', '、');
    let phone = record['手机号'];
    record['手机号'] = phone ? (phone + '').trim().replaceAll('\n', '') : '';
    let Email = record['邮箱']
    record['邮箱'] = Email ? (Email + '').trim().replaceAll('\n', '') : '';

    //去除空格
    let purpose = record['用途'];
    let r_purpose = purpose ?.trim();
    record['用途'] = r_purpose;

    //导入表格时自动备注“捐赠物”（手动更改未关联）
    // if (r_purpose.startsWith('捐赠物')) {
    //     record['项目备注'] = '捐赠物';
    // }


    //开立票据名称字段验证 必填 限制字数 有/\&需提示报错
    if (record['开立票据名称']) {
        record.billNameValid = true;
        let billName = record['开立票据名称'];

        // 限制字数
        if (billName.length >= 200) {
            record.billNameValid = false;
            record.billNameValidReason = '字数过多，请检查！';
        } else if (billNameReg.test(billName)) {//包含 & ，.等特殊符号
            record.billNameValid = false;
            record.billNameValidReason = billNameRegMsg;
        }

    } else {
        record.billNameValid = false;
    }

    // //备注字段验证 非必填 限制字数
    // record.remarkValid = true;
    // if (record['备注']) {
    //     if (record['备注'].length >= 200) {
    //         record.remarkValid = false;
    //         record.remarkValidReason = '字数过多，请检查！';
    //     }
    // }

    // 身份证号和TIN导入时，字段为空字符串时，去除空格
    if (typeof record['身份证号'] == 'string') {
        record['身份证号'] = record['身份证号'].trim();
    }
    record.idcValid = /^\w{0,18}$/.test(record['身份证号']);//不大于18位

    if (typeof record['纳税人识别号'] == 'string') {
        record['纳税人识别号'] = record['纳税人识别号'].trim();
    }
    if (typeof record['地址'] == 'string') {
        record['地址'] = record['地址'].trim();
    }
    // record.creditNoValid = record['TIN'] == undefined ? true : /^(\w{18}|\w{0})$/.test(record['TIN']);//固定18位或不填
    record.creditNoValid = true;//暂时不验证TIN
    // console.log('creditNo:', record['TIN'], typeof record['TIN']);
    record.amtValid = amtReg.test(record['金额']);//大于0.00，最多两位小数

    // 用途字段 必填且必须带‘-’
    record.purposeValid = /^(?!undefined)\S+$/.test(record['用途']);

    // 用途提示
    // console.log('projectArr:', projectArr);
    // let projectTypeSet = new Set();
    // let projectNameSet = new Set();
    // for (var p of projectArr) {
    //     projectTypeSet.add(p.split('-')[0]); // 捐赠款 捐赠物
    //     projectNameSet.add(p.split('-')[1]); // 慈善、医疗、教育、人文环保、可能的新项目
    // }
    // console.log('projectNameSet:', projectNameSet);

    // arr转set
    // let projectTypeArr = [...projectTypeSet];
    // let projectTypeReg = '';
    // projectTypeArr.forEach((p, i) => {
    //     projectTypeReg += p + (i + 1 == projectTypeArr.length ? '' : '|');
    // })
    // console.log('projectTypeReg:', projectTypeReg);

    // arr转set
    // let projectNameArr = [...projectNameSet];
    // let projectNameReg = '';
    // projectNameArr.forEach((p, i) => {
    //     projectNameReg += p + (i + 1 == projectNameArr.length ? '' : '|');
    // })
    // console.log('projectNameReg:', projectNameReg);

    // record.purposeValid = /(捐赠款|捐赠物)-(慈善|医疗|教育|人文环保)$/.test(record['用途']);
    // 用途字段正则验证，根据用户的权限 动态验证

    // record.purposeValid = new RegExp("(" + projectTypeReg + ")-(" + projectNameReg + ")$").test(record['用途']);
    //@PHI-TODO
    // record.purposeValid = projectArr.every(item => item?.ch_pro != record['用途']) ? false : true
    record.purposeValid = true;//暂时放开
    record.volunteerNoValid = record['志工编号'] ? true : false;//必填;
    record.volunteerNameValid = true;//直接过;
    record.phoneValid = !record['手机号'] || /^1\d{10}$/.test(record['手机号']);

    //邮箱验证修改
    //去空格，替换不正确的“.com .cn”
    record['邮箱'] = record['邮箱'].replaceAll(/\s/g, '').replaceAll(/([,，。]com)/g, '.com').replaceAll(/([,，。]cn)/g, '.cn');
    // console.log(record['邮箱']);
    record.emailValid = (!record['邮箱']) || emailReg.test(record['邮箱']);
    record.emailQQValid = goodQQEmailReg.test(record['邮箱']);

    // @tmpmdel
    // // 非陆籍填1的验证
    // record.outlandValid = true;
    // // 先转string，再去空格
    // record['非陆籍填1'] = String(record['非陆籍填1']);
    // record['非陆籍填1'] = record['非陆籍填1'].trim();
    // // 不为1或'' 则验证不通过
    // if (record['非陆籍填1'] != '' && record['非陆籍填1'] != '1') {
    //     record.outlandValid = false;
    // }


    // // 自然人法人验证
    // record.legalValid = true;
    // // 先转string，再去空格
    // record['法人填1，自然人不填'] = String(record['法人填1，自然人不填']);
    // record['法人填1，自然人不填'] = record['法人填1，自然人不填'].trim();
    // // 不为1或'' 则验证不通过
    // if (record['法人填1，自然人不填'] != '' && record['法人填1，自然人不填'] != '1') {
    //     record.legalValid = false;
    // }
    // 填了信用代码，必须选法人
    // record.legalRequireValid = true;
    // if (record['信用代码证号'] && record.creditNoValid && record['法人填1，自然人不填'] != '1') {
    //     record.legalRequireValid = false;
    // }

    // if (typeof record['项目备注'] == 'string') {
    //     record['项目备注'] = record['项目备注'].trim();
    // }
    // record.pmkValid = /^\w{0,100}$/.test(record['项目备注']);//不大于100位



    record.rcdValid = record.billNameValid && record.idcValid && record.creditNoValid && record.amtValid && record.purposeValid &&
        record.volunteerNoValid && record.volunteerNameValid && record.phoneValid && record.emailValid
        //  && record.pmkValid
        ;

    return record;
}

export { getDataResourceWithValid, getRecordWithValid }